import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

const InvitePage = () => import('./pages/InvitePage.vue')
const SharePage = () => import('./pages/SharePage.vue')
const TrialPage = () => import('./pages/TrialPage.vue')
const ConsentPage = () => import('./pages/ConsentPage.vue')
const StatusPage = () => import('./pages/StatusPage.vue')
const HelpPage = () => import('./pages/HelpPage.vue')
const LegalPage = () => import('./pages/LegalPage.vue')

export const h5Screens = {
  'SC-H5-001': InvitePage,
  'SC-H5-002': SharePage,
  'SC-H5-003': TrialPage,
  'SC-H5-004': ConsentPage,
  'SC-H5-005': StatusPage,
  'SC-H5-006': HelpPage,
  'SC-H5-007': LegalPage,
} as const

export const routes: RouteRecordRaw[] = [
  { path: '/invite/:token', name: 'SC-H5-001', component: InvitePage },
  { path: '/i/:token', component: InvitePage },
  { path: '/share/:token', name: 'SC-H5-002', component: SharePage },
  { path: '/s/:token', component: SharePage },
  { path: '/try', name: 'SC-H5-003', component: TrialPage },
  { path: '/consent', name: 'SC-H5-004', component: ConsentPage },
  { path: '/status', name: 'SC-H5-005', component: StatusPage },
  { path: '/help/:pathMatch(.*)*', name: 'SC-H5-006', component: HelpPage },
  { path: '/legal/:pathMatch(.*)*', name: 'SC-H5-007', component: LegalPage },
  { path: '/', redirect: '/try' },
  { path: '/:pathMatch(.*)*', redirect: '/status' },
]

export const router = createRouter({ history: createWebHistory(), routes, scrollBehavior: () => ({ top: 0 }) })
